import React, { PropTypes } from 'react';
import './styles.scss';
import * as URLConstants from '../../constants';

class SiteHeader extends React.Component {
  constructor(props) {
    super(props);
    //this.state = {};
  }

  render () {
    let logo = "/images/logo.svg",
        featuresURL = `${URLConstants.MarketingRootURL}/#features`,
        pricingURL = `${URLConstants.MarketingRootURL}/#pricing`,
        loginURL = `${URLConstants.AppRootURL}/login`;

    return (
      <header>
        <div className="SetterBase-row">
          <div className="SetterBase-col SetterBase-medium-c-4 logo-cage">
            <a className="logo" href="/">
              <img src={logo}/>
            </a>
          </div>
          <div className="SetterBase-spacer-short visible-xs visible-sm"></div>
          <div className="SetterBase-col SetterBase-medium-c-8 nav-cage">
            <ul className="nav inline-list">
              <li><a className="feature-btn" href={featuresURL}>FEATURES</a></li>
              <li><a className="feature-btn" href={pricingURL}>PRICING</a></li>
              {/* <li><a href="#">ABOUT</a></li> */}
              <li><a href={loginURL} className="signup-btn setter-btn">LOGIN</a></li>
              {/* <li><a href="http://app.setter.io/register" className="signup-btn setter-btn">SIGN UP</a></li> */}
            </ul>
          </div>
        </div>
      </header>
    );
  }
}

SiteHeader.propTypes = {

};

SiteHeader.defaultProps = {

};

export default SiteHeader;



/** WEBPACK FOOTER **
 ** ../components/SiteHeader/index.js
 **/